module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAilBMVEVHcEz/aCb/ZiX/////////////////////ZiT/Zib////////////////////////////////////////////////////e4eP////////////+/v7e4eP////////+/v7f4uT/aCX/ZiL/Yxz/bST/////aCbp6+y0u8C9xMjFy8/t7/Dx8/Ozur9FtWQ+AAAAJXRSTlMA5FrUvyD+GlUUwkFFPLg3M74MtDWqsP0xLC+q/i6urP1MHhIHUye5CQAAAHlJREFUKM9jYBhKQEKMHbeklBybKk5pWXkZXR1c0pLSChqa2qoY0qwgICIqrqGprqqKKa0KAVrqEBqHNAywqzAxKeGR5lRT4xia0sqMjIp4pNGChQUEmHFKQwAPF15pBgZuQbzSDAy8fHilGRj4hdnY8SY2AaFBkeYB2fshDD9+9OgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/notice.png
// module id = 8MXu
// module chunks = 1